import type { SupportedBrannanHeaderPhotoLayout } from '@shared/types/WebsiteHeaderSettings.types';

// Every in-flow HeaderV2 layout (renders EventNameNav). The standalone background
// variants (photoBackground/videoBackground/*Monogram) never reach HeaderV2, but the
// explicit allowlist keeps the compatibility contract auditable and adjustable.
//
// Complement of STANDALONE_HERO_LAYOUTS in ./standaloneHeroLayout: the two are meant to partition
// the layout space, and standaloneHeroLayout.spec.ts asserts they stay disjoint and exhaustive.
// Adding a layout here means checking it does not also belong there.
const COMPATIBLE_LAYOUTS: ReadonlySet<SupportedBrannanHeaderPhotoLayout> = new Set<SupportedBrannanHeaderPhotoLayout>([
  'center',
  'fullWidth',
  'pageWidth',
  'photoSlider',
  'photoSliderPageWidth',
  'photoTrio',
  'photoTrioPageWidth',
  'noPhoto',
  'monogram',
  'photoArch',
  'photoDuoLeft',
  'photoDuoRight',
  'photoMarquee',
  'photoMarqueePageWidth',
  'videoArch',
]);

export const isMastheadCompatibleLayout = (layout: Maybe<SupportedBrannanHeaderPhotoLayout>): boolean => {
  return !!layout && COMPATIBLE_LAYOUTS.has(layout);
};
